import store from '@/app/store/store';
import { types } from '@/app/types/types';
import { appBusyStateEnum } from "@/app/enums/common";
import { componentBusyStateEnum } from "@/app/enums/common";
import { appFeedbackStateEnum } from "@/app/enums/common";

export default {

	install(Vue)
	{
		Vue.mixin(
			{
				mounted()
				{
					window.isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)

					if (window.isSafari)
					{
						document.getElementById("app").setAttribute("class", "issafari")
					}
				},
				computed:
				{
					isloggedIn: function ()
					{
						return store.getters[types.GET_IS_USER_LOGGED_IN]
					},

					isAppBusy: function ()
					{
						return store.getters[types.GET_APP_BUSY_STATE] == appBusyStateEnum.BUSY
					},

					isComponentBusy: function ()
					{
						return store.getters[types.GET_COMPONENT_BUSY_STATE] == componentBusyStateEnum.BUSY
					},

					isAppBusyModal: function ()
					{
						return store.getters[types.GET_APP_BUSY_STATE] == appBusyStateEnum.BUSYMODAL
					},

					isModalProfileEditVisible: function ()
					{
						return store.getters[types.GET_MODAL_PROFILEEDIT_IS_VISIBLE]
					},

					feedbackShowSucces: function ()
					{
						let state = store.getters[types.GET_APP_FEEDBACK_STATE]
						return (state == appFeedbackStateEnum.SUCCESS) || (state == appFeedbackStateEnum.ADDED) || (state == appFeedbackStateEnum.UPDATED)
					},

					feedbackShowAdded: function ()
					{
						return store.getters[types.GET_APP_FEEDBACK_STATE] == appFeedbackStateEnum.ADDED
					},

					feedbackShowUpdated: function ()
					{
						return store.getters[types.GET_APP_FEEDBACK_STATE] == appFeedbackStateEnum.UPDATED
					},

					feedbackShowDeleted: function ()
					{
						return store.getters[types.GET_APP_FEEDBACK_STATE] == appFeedbackStateEnum.DELETED
					},

					feedbackShowFailed: function ()
					{
						return store.getters[types.GET_APP_FEEDBACK_STATE] == appFeedbackStateEnum.FAILED
					},

					isNotificationVisible: function ()
					{
						return store.getters[types.GET_IS_NOTIFICATION_SHOWN]
					},

					globalShownNotification: function ()
					{
						return store.getters[types.GET_NOTIFICATION_SHOWN]
					}
				},

				methods:
				{
					setAppAsIdle: function ()
					{
						this.$store.dispatch(types.ACTION_SET_APP_AS_IDLE)
					},

					setAppAsBusy: function ()
					{
						this.$store.dispatch(types.ACTION_SET_APP_AS_BUSY)
					},

					setAppAsBusyModal: function ()
					{
						this.$store.dispatch(types.ACTION_SET_APP_AS_BUSYMODAL)
					},

					setComponentAsIdle: function ()
					{
						this.$store.dispatch(types.ACTION_SET_COMPONENT_BUSY_STATE, componentBusyStateEnum.IDLE)
					},

					setComponentAsBusy: function ()
					{
						this.$store.dispatch(types.ACTION_SET_COMPONENT_BUSY_STATE, componentBusyStateEnum.BUSY)
					},

					setModalProfileEditVisibility: function (visibility)
					{
						this.$store.dispatch(types.ACTION_SET_MODAL_PROFILEEDIT_VISIBILITY, visibility)
					},

					setAppFeedbackState: function (feedbackState)
					{
						this.$store.dispatch(types.ACTION_SET_APP_FEEDBACK_STATE, feedbackState)
						var comp = this;

						setTimeout(function ()
						{
							comp.$store.dispatch(types.ACTION_SET_APP_FEEDBACK_STATE, appFeedbackStateEnum.NONE)
						}, 2500)
					},

					setModalIsVisible: function ()
					{
						this.$store.dispatch(types.ACTION_SET_MODAL_VISIBILITY, true)
						document.getElementsByTagName("body")[0].classList.add("modaloverflow");
					},

					setModalNotVisible: function ()
					{
						this.$store.dispatch(types.ACTION_SET_MODAL_VISIBILITY, false)
						document.getElementsByTagName("body")[0].classList.remove("modaloverflow");
					},

					getNonXHRParameter: function ()
					{
						return "?t=" + this.$store.getters[types.GET_USER_DATA].token;
					},

					showErrorAlert: function (message)
					{
						if (this.isloggedIn)
						{
							alert(message);
						}
					}
				}
			})
	}
}

// TODO: Encapsulate in helper class
if (window.location.toString().indexOf("://localhost") > -1 ||
	window.location.toString().indexOf(".local") > -1 ||
	window.location.toString().indexOf("://192.168") > -1)
{
	window.env = "dev"
}

window.log = function (message, alwaysShow = false)
{
	if (window.env == "dev" || alwaysShow)
	{
		console.log(message)
	}
}

window.logDebug = function (reference, message, payload)
{
	log("Debug[" + reference + "]" + (payload ? " (" + payload + ")" : "") + (message ? " :" + message : ""))
}

window.logError = function (reference, message, payload)
{
	log("Error[" + reference + "]" + (payload ? " (" + payload + ")" : "") + (message ? " :" + message : ""), true)
}